import { render, staticRenderFns } from "./EditorCourseTree.vue?vue&type=template&id=3372e478&scoped=true"
import script from "./EditorCourseTree.vue?vue&type=script&lang=js"
export * from "./EditorCourseTree.vue?vue&type=script&lang=js"
import style0 from "./EditorCourseTree.vue?vue&type=style&index=0&id=3372e478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3372e478",
  null
  
)

export default component.exports